import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import { history } from 'react-router-guard';
const lang = history.location.pathname.split('/')[1];
i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    react: {
      useSuspense: false,
    },

    lng: lang || 'en',
    fallbackLng: 'de',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
